function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd",
  strokeMiterlimit: 8
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m16.447 34.804 0.7798-10.602c-14.683-2.9693-20.865-10.385-13.809-16.563 7.0564-6.1783 24.678-8.7795 39.361-5.8102s20.865 10.385 13.811 16.563c-5.2123 4.56-16.477 7.3336-28.474 7.0099z",
  fill: "#fff",
  stroke: "#002060"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m25.558 13.014c0-2.4548 1.988-4.4449 4.4446-4.4449s4.4446 1.9901 4.4446 4.4449-1.988 4.4449-4.4446 4.4449-4.4446-1.9901-4.4446-4.4449z",
  fill: "#adb9ca"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m10.702 13.014c0-2.4548 1.99-4.4449 4.4446-4.4449 2.4567 0 4.4446 1.9901 4.4446 4.4449s-1.988 4.4449-4.4446 4.4449c-2.4546 0-4.4446-1.9901-4.4446-4.4449z",
  fill: "#ecaec6"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m40.415 13.014c0-2.4548 1.988-4.4449 4.4446-4.4449s4.4446 1.9901 4.4446 4.4449-1.988 4.4449-4.4446 4.4449-4.4446-1.9901-4.4446-4.4449z",
  fill: "#ecaec6"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
}, React.createElement("path", {
  d: "m10.584 13.014c0-2.4548 1.99-4.4449 4.4446-4.4449 2.4567 0 4.4446 1.9901 4.4446 4.4449s-1.988 4.4449-4.4446 4.4449c-2.4546 0-4.4446-1.9901-4.4446-4.4449z"
}), React.createElement("path", {
  d: "m25.558 13.014c0-2.4548 1.988-4.4449 4.4446-4.4449s4.4446 1.9901 4.4446 4.4449-1.988 4.4449-4.4446 4.4449-4.4446-1.9901-4.4446-4.4449z"
}), React.createElement("path", {
  d: "m40.592 13.014c0-2.4548 1.988-4.4449 4.4446-4.4449s4.4446 1.9901 4.4446 4.4449-1.988 4.4449-4.4446 4.4449-4.4446-1.9901-4.4446-4.4449z"
}));

var SvgMenuTextAnalytics = function SvgMenuTextAnalytics(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    overflow: "hidden",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuTextAnalytics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu-text-analytics.1bb3eeae.svg";
export { ForwardRef as ReactComponent };